import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 35%;

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const Heading = styled.div`
  padding: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    height: 40px;
  }
`;

export const RecoveryLink = styled.p`
  cursor: pointer;
  background: transparent;
  width: 100%;
  color: var(--primary);
  font-size: 16px;
  padding: 20px 0;
  margin-bottom: 40px;
  font-weight: 500;
`;

export const TransparentButton = styled.button`
  cursor: pointer;
  background: transparent;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--primary);
  font-size: 16px;
  outline: none;
  margin-top: 20px;
  font-weight: 400;

  > b {
    margin-left: 5px;
  }
`;

export const Warning = styled.div`
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;

  min-height: 100vh;
  width: 100vw;
  background: var(--white-dark);
  padding: 40px 10%;

  > img {
    height: 30px;
    margin-bottom: 40px;
  }

  > h2 {
    color: var(--primary);
  }

  > p {
    max-width: 450px;
    margin-top: 20px;
    color: var(--black-7);
  }
`;
